// MARK://dhk8/pos/clients/preferences
// Lane #174 — user preferences (tema dark/light + density + fontScale).
//
// El theme dark/light se persiste en User.preferences del backend, no en
// localStorage. Esto hace que el setting siga al login: cualquier terminal
// donde el user se loguee arranca con su preferencia. localStorage queda
// como fallback temprano antes de que el bearer esté disponible y como
// "modo invitado" cuando no hay sesión.
//
// Endpoints:
//   GET  /v1/auth/me/preferences  → { preferences: null | {...} }
//   PATCH /v1/auth/me/preferences → body parcial { theme?, density?, fontScale? }
//                                   merge shallow en backend → { preferences: {...} }

import { apiData, BACKENDS } from '../api.js'

export type ThemePref = 'light' | 'dark'
export type DensityPref = 'comfortable' | 'compact'
export type FontScalePref = 'small' | 'default' | 'large'

export interface UserPreferences {
  theme?: ThemePref
  density?: DensityPref
  fontScale?: FontScalePref
}

interface PreferencesEnvelope {
  preferences: UserPreferences | null
}

/** GET /v1/auth/me/preferences. Devuelve `null` si el user aún no setea nada. */
export async function fetchMyPreferences(): Promise<UserPreferences | null> {
  const res = await apiData<PreferencesEnvelope>(`${BACKENDS.auth}/me/preferences`, {
    method: 'GET',
  })
  return res.preferences ?? null
}

/** PATCH /v1/auth/me/preferences. Merge shallow en backend. */
export async function patchMyPreferences(patch: UserPreferences): Promise<UserPreferences> {
  const res = await apiData<PreferencesEnvelope>(`${BACKENDS.auth}/me/preferences`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
    headers: { 'content-type': 'application/json' },
  })
  return res.preferences ?? {}
}
